import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GlobalStyles } from './styles/GlobalStyles';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './AppLayout';
import HomePage from './pages/HomePage';
import ClonePage from './pages/ClonePage';
import VoicePage from './pages/VoicePage';
import VideoPage from './pages/VideoPage';
import GalleryPage from './pages/GalleryPage';
import ConfigPage from './pages/ConfigPage';
import AgentPage from './pages/AgentPage';
import SearchPage from './pages/SearchPage';
import MixCutPage from './pages/MixCutPage';
import SuperIPPage from './pages/SuperIPPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { authenticated, loading } = useAuth();
  
  if (loading) {
    return <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      color: 'var(--primary)',
      fontFamily: 'Orbitron, sans-serif'
    }}>
      加载中...
    </div>;
  }
  
  if (!authenticated) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

// 布局包装器
const LayoutWrapper = ({ children }) => {
  const { authenticated } = useAuth();
  
  if (!authenticated) {
    return children;
  }
  
  return <Layout>{children}</Layout>;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <GlobalStyles />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <HomePage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/clone" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <ClonePage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/voice" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <VoicePage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/video" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <VideoPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/gallery" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <GalleryPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/config" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <ConfigPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/admin" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <AdminPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/agent" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <AgentPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/search" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <SearchPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/mix-cut" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <MixCutPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
          
          <Route path="/super-ip" element={
            <ProtectedRoute>
              <LayoutWrapper>
                <SuperIPPage />
              </LayoutWrapper>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
